<template>
  <div class="sezione "  style="padding:0 20px;">

<div class="yo-fixed-top" style="top:132px;z-index:999;">
<div class="row el-container" style="background:#fff;padding:16px 20px;">
   <div class="col s12">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="">
         <el-breadcrumb-item>Report</el-breadcrumb-item>
         <el-breadcrumb-item>Schede</el-breadcrumb-item>
      </el-breadcrumb>
   </div>
</div>
</div>

<div >
<div class="title_h1 yo-color-primary" style="margin-top:30px;">REPORT SCHEDE</div>
<br />
In questa sezione potete avere una reportistica delle schede inserite

</div>

<div class="yo-color-primary yo-text-bold" style="margin-top:32px;margin-bottom:16px;">SCHEDE ANDAMENTO</div>

<div class="row">

   <div class="col s3 yo-text-bold">INSERITE</div>
   <div class="col s9">{{$teras._schede.length}} </div>

</div>
<div class="row" style="margin-top:16px;">

   <div class="col s3 yo-text-bold clear">COMPLETATE</div>
   <div class="col s9">{{$teras._schede_esito[0].totale}} </div>

   <div class="col s3 yo-text-bold clear">10 RISPOSTE</div>
   <div class="col s9">{{$teras._schede_esito[1].totale}} </div>

   <div class="col s3 yo-text-bold clear">30 RISPOSTE</div>
   <div class="col s9">{{$teras._schede_esito[2].totale}} </div>

   <div class="col s3 yo-text-bold clear">50 RISPOSTE</div>
   <div class="col s9">{{$teras._schede_esito[3].totale}} </div>

   <div class="col s3 yo-text-bold clear">OLTRE LE 50 RISPOSTE</div>
   <div class="col s9">{{$teras._schede_esito[4].totale}} </div>


</div>



   



  </div>
</template>

<script>
export default {
  mounted() {
     this.$teras.event.emit('pazienteLoad')
   }
}
</script>

